module.exports = function() {
  return new Worker(__webpack_public_path__ + "271a0af2ee03d2a248cd.worker.js");
};